module.exports = __webpack_public_path__ + "static/media/cancel.37a8d192.svg";